






import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import { StandardOption } from "../../../../base/components/system/selectors/mixins";
import { OptionDropDownSelector } from "../../../../base/components/system/selectors";
import { DomainRegistry } from "../../../domain";
import { EditableFormatSummary } from "../../../domain/editableFormat";

@Component({
  components: {
    selector: OptionDropDownSelector,
  }
})
export default class FormatArchiveSelector extends Mixins(ModelEditableMixin) {
  @Prop({ default: null })
  formatId: number;

  @Prop({ default: null })
  archiveId: number;

  archives: EditableFormatSummary[] = null;

  get isLoaded(): boolean {
    return !!this.archives;
  }

  get options(): StandardOption<EditableFormatSummary>[] {
    return !this.archives
      ? []
      : Enumerable.from(this.archives)
        .select(s => new StandardOption<EditableFormatSummary>("第" + s.edition + "版：" + (s.deleted ? "削除済" : s.isTemporary ? "一時保存" : "登録"), s))
        .toArray();
  }

  get maxEdition(): number {
    return Enumerable.from(this.archives)
      .max(e => e.edition);
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  created(): void {
    this.updateArchiveFormats();
  }

  @Watch("formatId")
  onFormatIdUpdated(newValue: number, oldValue: number): void {
    this.updateArchiveFormats();
  }

  updateArchiveFormats(): void {
    if (!this.formatId) {
      this.archives = [];
      this.editingSource = null;
      return;
    }
    this.archives = null;
    DomainRegistry.instance.editableFormat.getFormatRepository().getFormatArchives(this.formatId)
    .then(d => {
      this.archives = d;
      this.editingSource = this.toInitialModel(d);
    }).catch(e => {
      this.$error(
        this.formatNameWording + "履歴取得失敗",
        this.formatNameWording + "履歴を取得できませんでした。",
        e,
      );
      this.archives = [];
    });
  }

  private toInitialModel(source: EditableFormatSummary[]): EditableFormatSummary {
    return Enumerable.from(source)
      .firstOrDefault(e => (e.archiveId === this.archiveId) || (e.edition === this.maxEdition));
  }
}
